import request from "@/services/request"
import baseUrl from "@/services/baseUrl"

// let path =  `${baseUrl.main}/${baseUrl.envName != 'development'? "cs/": ''}cs/v1/`;
let path = `${baseUrl.main}/v1/`;
// let path = `http://localhost:6050/v1/`;
let ucPath = `${baseUrl.main}/${baseUrl.envName != 'development' ? "uc/" : ''}v1/`;

// this is for globally used APIs only
export default {
  getTransactions: (params = '') => request.get(path + "transactions/bo/list?limit=10&" + params, params),
  postTransaction: (params = {}) => request.post(path + "txn/bo/post-transaction-process", params),
  refreshTransaction: (params = '') => request.post(path + "transactions/callback-ctx/" + params),
  getUser: (params = '') => request.get(ucPath + "bo/regular/single/" + params),
  // review: (params = {}) => request.post(baseUrl.main + "/ba021/v1/rnv/user/applications/review", params)
}